import { render, staticRenderFns } from "./PageSection.ts.vue?vue&type=template&id=6f524e79&"
import script from "./PageSection.ts.vue?vue&type=script&lang=ts&"
export * from "./PageSection.ts.vue?vue&type=script&lang=ts&"
import style0 from "./PageSection.ts.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports